<template>
    <el-select v-model="change" placeholder="请选择" multiple filterable :style="{width: width}" @change="selectChange">
        <el-option-group
            v-for="(group, index) in selectData"
            :label="group.label" :key="index">
            <el-option
                v-for="(item, i) in group.options"
                :label="item.label"
                :value="item.value" :key="i">
            </el-option>
        </el-option-group>
    </el-select>
</template>
<script>
    export default {
        name: 'LySelectWarehouse',
        props: {
            value: {
                type: Array,
                default: () => []
            },
            width: {
                type: String,
                default: '100%'
            }
        },
        data () {
            return {
                selectData: [{
                    label: '选择全部',
                    options: [{
                        label: '全部',
                        value: 0
                    }]
                }, {
                    label: '仓库列表',
                    options: []
                }],
                change: [], // 列表选中的值
                warehouseIds:[], // 仓库ID集合，在全选时用到
                isBind: false // 是否已经绑定过value自带的值
            } 
        },
        created () {
            this.queryData()
        },
        watch: {
            value (val) {
                this.initBindValue(val)
            }
        },
        methods: {
            /**
             * 初始化绑定默认的数据
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            initBindValue (val) {
                if (val && val.length > 0 && !this.isBind) {
                    this.change = val
                    this.isBind = true
                    // 全选的判断
                    this.initIsAll()
                }
            },
            /**
             * 初始化验证是否是全选
             * @return {[type]} [description]
             */
            initIsAll () {
                if (this.change.length > 0 && this.change.length === this.warehouseIds.length) {
                    this.change = [0]
                }
            },
            /**
             * 获得仓库数据
             * api/warehouse
             */
            queryData () {
                this.$api.query('api/warehouse').then((rs) => {
                    rs.forEach((v) => {
                        this.warehouseIds.push(v.value)
                    })
                    // 初始默认数据的绑定
                    this.isBind = false
                    this.initBindValue(this.value)
                    // 设置仓库列表的值
                    this.selectData[1]['options'] = rs
                })
            },
            /**
             * 列表的选择
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            selectChange (val) {
                // 设置选中之后不再绑定值
                this.isBind = true
                let isAll = val.indexOf(0)
                if (isAll >= 0 && this.change.length > 1) {
                    this.change = [0]
                }
                this.updateValue()
            },
            updateValue () {
                // 判断全选状态
                if (this.change.length === 1 && this.change[0] === 0) {
                    this.$emit('input', this.warehouseIds)
                } else {
                    this.$emit('input', this.change)
                }
            }
        }
    }
</script>